<template>
    <div class="animated fadeIn er-form">        
        <b-card>
            <div slot="header">
                Expense Reimbursment Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-form-row>
                        <b-col md="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tglRequ" type="date" @change="tanggalBerubah" disabled></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-form-row >                      
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.crewinfo" :state="!$v.model.crewkey.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuCrewShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group>
                                <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                                <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                                <b-input-group-append >
                                <b-btn text="Button" @click="lkuBudgetShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>  
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input v-model="model.keterangan" :state="!$v.model.keterangan.$error"></b-form-input>
                        <b-input-group-append><span class="input-group-text" style="width:70px;">{{model.nomorproduksi}}</span></b-input-group-append>                                
                    </b-input-group>
                    <b-row>
                        <b-col lg="6">   
                            <b-input-group >
                                <b-input-group-prepend><label>Paid To</label></b-input-group-prepend>
                                <b-form-input v-model="model.dibayarke" :state="!$v.model.dibayarke.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Expected Payment</label></b-input-group-prepend>
                                <b-form-input v-model="model.tglBayar" type="date"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>                      

                    <b-row>
                        <b-col cols="6" >
                            <b-input-group >
                                <b-input-group-prepend><label>Total Reimbursment</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.jumlah" :precision="2" :state="!$v.model.jumlah.$error"></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col cols="5">                            
                            <b-input-group>
                                <b-input-group-prepend><span class="pt-2">Exch. Rate {{model.matauang}} &nbsp;</span></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.ratekurs" :state="!$v.model.ratekurs.$error"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <b-form-group label-for="apKodecash">
                        <b-input-group >
                            <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblExpLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="expLines.items"
                    :fields="expLines.fields"
                    :current-page="expLines.page"
                    :per-page="expLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(pasalpph)="data">
                            <span v-if="(data.item.pph)">
                                {{data.item.pasalpph}} {{data.item.pph|numFormat}}%
                            </span>
                        </template>
                        <template v-slot:cell(grossup)="data">
                        <span v-if="data.item.grossup==1"><i class="fa fa-check "></i></span>
                        </template>
                        
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editExpLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delExpLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                        <b-row>
                        <b-col md="6" lg="7">
                            <b-input-group v-if="(model.ibudghdkey)">
                                <b-input-group-prepend><label>Intern.Budget Line</label></b-input-group-prepend>
                                <b-form-input v-model="expLinesObj.budgetline" :state="!$v.expLinesObj.ibudgdtkey.$error" readonly></b-form-input>
                                <b-input-group-append >
                                <b-btn text="Button" @click="lkuBudgetInternShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                                <b-form-checkbox v-model="expLinesObj.ibudgdtkeyflag" value="YES" unchecked-value="NO"  class="ml-2 pt-2">NOT RELATED</b-form-checkbox>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                <b-form-input v-model="expLinesObj.uraian" :state="!$v.expLinesObj.uraian.$error"></b-form-input>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>GL Account No.</label></b-input-group-prepend>
                                <b-form-input v-model="expLinesObj.kodeacc" :state="!$v.expLinesObj.kodeacc.$error"></b-form-input>
                                <b-form-input readonly v-model="expLinesObj.namaacc" @keyup.13.native="lkuCoaShow=true" :state="!$v.expLinesObj.kodeacc.$error"  style="width:50% !important;"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuCoaShow=true" id="glAccount">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-row>
                              <b-col lg="5">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="expLinesObj.nilai" :minus="true" :precision="2" :state="!$v.expLinesObj.nilai.$error"></my-number>
                                </b-input-group>
                              </b-col>
                              <b-col lg="7">                            
                                <b-input-group>
                                    <b-input-group-prepend><label style="width:50px">Date</label></b-input-group-prepend>
                                    <b-form-input v-model="expLinesObj.duedate" type="date" :state="!$v.expLinesObj.duedate.$error"></b-form-input>
                                    <b-input-group-prepend><label style="width:50px">No.Reff</label></b-input-group-prepend>
                                    <b-form-input v-model="expLinesObj.reff" placeholder="Bill/Inv No. " ></b-form-input>
                                </b-input-group>
                              </b-col>
                            </b-form-row > 

                            <b-form-row>
                              <b-col  md="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>PPN Masukan</label></b-input-group-prepend>
                                    <b-form-select v-model="expLinesObj.kenappn" :plain="true" :options="YesNo" @change="calcTaxes()" ></b-form-select>
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">tarif</span></b-input-group-prepend>
                                    <b-form-input v-model="expLinesObj.ppn"  type="number" :disabled="(expLinesObj.kenappn != 1)"></b-form-input>
                                    <b-input-group-append> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                                </b-input-group>
                              </b-col>
                              <b-col md="5">           
                                <b-input-group>
                                    <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                                        <b-form-checkbox id="chkGrossUp" class="ml-2 mt-2" v-model="expLinesObj.grossup" value=1 unchecked-value=0 >
                                        PPH Gross Up
                                        </b-form-checkbox>
                                </b-input-group>
                              </b-col>
                            </b-form-row >                      
                            <b-form-row>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>PPH dipotong</label></b-input-group-prepend>
                                    <b-form-select v-model="expLinesObj.pasalpph" :plain="true" :options="lookupPPH" ></b-form-select>
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">tarif</span></b-input-group-prepend>
                                    <b-form-input v-model="expLinesObj.pph" type="number"  ></b-form-input>
                                    <b-input-group-append> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                                </b-input-group>
                              </b-col>
                              <b-col md="6">                            
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <b-form-select style="width:158px;font-size:small;"  v-model="calcPPh" :plain="true" :options="calcuationPPH" ></b-form-select>
                                    </b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="expLinesObj.nilaipph" :minus="true" :precision="2" :readonly="(calcPPh===1)"></my-number>
                                </b-input-group>
                              </b-col>
                            </b-form-row >                                                           
                        </b-col>
                        <b-col md="6" lg="5">
                            <v-dim :model="expLinesObj" :key="updateDimDtl" ></v-dim>
                            
                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mt-1">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveExpLines()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>

                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                        <b-row>
                            <b-button size="sm" class="ml-3" @click="addExpLines" >Add Expense Detail</b-button>                          
                            <!-- <b-button size="sm" class="ml-1" v-if="!adminAdv" @click="lkuExpnoteShow=true">Ambil Dari Catatan</b-button>                           -->
                            <b-button size="sm" class="ml-1"  @click="lkuExpnoteShow=true">Ambil Dari Catatan</b-button>                          
                            <div class="ml-2 mt-1" >
                            Showing {{(expLines.page - 1) * expLines.limit + 1}}
                            to <span v-if="((expLines.page * expLines.limit)>expLines.total)">{{expLines.total}}</span> <span v-else>{{expLines.page * expLines.limit}}</span>
                            of {{expLines.total}} entries   
                            </div>
                        </b-row>                    
                    </b-col>
                    <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="expLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                    <b-pagination
                        align="right"
                        :total-rows="expLines.total"
                        :per-page="expLines.limit"
                        v-model="expLines.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
              </b-card>    
                <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-form-row>
                            <b-col md="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>Payable Group</label></b-input-group-prepend>
                                    <b-form-select v-model="model.expenAcc" :plain="true" :options="postGroups" :state="!$v.model.expenAcc.$error"></b-form-select>
                                </b-input-group>
                            </b-col>
                        </b-form-row>                      
                    </b-col>
                    <b-col md="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">subtotal</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
            <b-row class="justify-content-center mb-2">
                <div style="width:450px;">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                        <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>

            </b-row>
        </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
            <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData" typeacc="OUT"></lku-cashflow>
        </b-modal>        
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuExpnoteShow" size="lg" :hide-footer="true" title="Catatan Pemakaian Dana" :centered="true">
            <lku-expnote @click="onSelectLkuExpnote" ></lku-expnote>
        </b-modal>        
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget" :centered="true">
            <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
        </b-modal>        
        <b-modal v-model="lkuBudgetInternShow" size="lg" :hide-footer="true" title="Internal Budget Items" :centered="true">
            <lku-budgetinternalline @click="onSelectLkuBudgetIntern" :ibudghdkey="model.ibudghdkey" :formdata="lkuBudgetInternData" :key="model.ibudghdkey" ></lku-budgetinternalline>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
  .er-form{
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
        .input-group {
            .input-group-prepend {
                label {
                    width: 100px;
                }
            }
        }
    }
  }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuBudgetinternal from "../lookup/lkuBudgetinternal";
import lkuBudgetinternalline from "../lookup/lkuBudgetinternallineLazzy";
import lkuCrew from "../lookup/lkuCrewlazzy";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuExpnote from "../lookup/lkuExpensenote";
import lkuCoa from "../lookup/lkuCoa";
import expense from "../../apis/expense";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, minValue, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim, Loading, lkuBudgetinternal, lkuBudgetinternalline, lkuCrew, lkuCashflow,lkuExpnote ,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            crewkey: { required },
            keterangan: { required },
            tglRequ: { required },
            expenAcc: { required },
            matauang: { required },
            dibayarke: { required },
            jumlah: { required, minValue:minValue(1) },
            ratekurs: { required, minValue:minValue(0.00000001) }
        },
        expLinesObj: {
            kodeacc: { required },
            uraian: { required },
            nilai: { required },
            duedate: { required },
            ibudgdtkey: { required:(function() {
                if (this.model.ibudghdkey) {
                    if (this.expLinesObj.ibudgdtkey) {
                        if (this.expLinesObj.ibudghdkey=='N/A')
                            return true;
                        else {
                            if (this.model.ibudghdkey==this.expLinesObj.ibudghdkey) {
                                return true;
                            } else {
                                toastr.error(`Budget Line not from Internal Budget`,'Line/Detail Expenses',10000);                                
                                return false;
                            }
                        }
                    } else return false;
                } else return true;
            }) },
        },
  }, 
  data() {
    return {
        watching_pasalpph: false,
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        isLoading:false,
        saveEnabled:true,
        lkuBudgetShow: false,
        lkuBudgetInternShow: false,
        lkuBudgetInternData:{},
        lkuExpnoteShow:false,
        lkuCashflowData: {},
        lkuCashflowShow: false,
        lkuCashflowCaller:'model',        
        lkuCrewData:{},
        lkuCrewShow: false,
        lkuPorderShow: false,
        updateDimHdr:false,
        updateDimDtl:true,
        tarifPPN: this.$store.state.user.tarifppn || 10,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        coa:[],
        uanguser: this.$store.state.user.matauang,
        postGroups:[],
        currency:[{value:'IDR',text:'IDR'}],
        YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
        expLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "glAccount",
                    label: "GL Account"
                },
                {
                    key: "nilai",
                    label: "Amount",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "pasalpph",
                    label: "PPH",
                    thStyle: "width:80px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "grossup",
                    label: "Gross Up",
                    thStyle: "width:60px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "reff",
                    label: "Reference Doc.",
                    thStyle: "width:180px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit:15,
            total: 0,
        },
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Otomatis)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],
        model: {
            crewkey: '',ibudghdkey:'',
            keterangan: '',
            tglRequ: '',
            expenAcc: '',
            kodecash: '',
            matauang:this.$store.state.user.matauang,
            dibayarke: '',
            jumlah: 0,
            ratekurs: 1, DimTableKey:'', final:1,Dim1:'',Dim1Txt:''
        },
        expLinesObj: {
            kodeacc: '',namaacc:'', glAccount:'', pph:0, pasalpph:'',
            ibudghdkey:'', ibudgdtkey:'',ibudgdtkeyflag:'YES',
            uraian: '',nilai: 0, DimTableKey:'', duedate:''
        },
        adminAdv:true,
        lkuCoaShow:false,inputBerlanjut:0, inputLineBerlanjut:1,
        routeAsal:'',
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidExpLines() {
      this.$v.expLinesObj.$touch();
      return this.$v.expLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    // nilai(){
    //     return this.expLinesObj.pasalpph;
    // },    

  },
  watch: {
    // nilai: function(newval) {
    //     setTimeout(() => {
    //         this.calcTaxes();
    //     }, 100);
    // },    
    'model.ibudghdkey': function(newval) {
        // setTimeout(() => {
            this.expLinesObj.ibudgkey='';   
            this.expLinesObj.ibudgdtkeyflag=='NO'
            this.expLinesObj.ibudgdtkey='';   
            this.expLinesObj.budgetline='';
            this.expLines.items.forEach((line)=>{
                line.ibudgdtkey='';
                line.budgetline='';
            });         
        // }, 200);
    },
    'expLinesObj.nilai': function(newval) {
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },    
    'expLinesObj.pph': function(newval) {
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },    
    'expLinesObj.ppn': function(newval) {
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },   
    'expLinesObj.grossup' : function(newval) {
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },   
    'model.ibudghdkey': function(newval) {
        // setTimeout(() => {
            this.expLinesObj.ibudgdtkeyflag=='YES'
            this.expLinesObj.ibudghdkey='N/A';
            this.expLinesObj.ibudgdtkey='N/A';
            this.expLinesObj.budgetline='';
            // this.expLines.items.forEach((line)=>{
            //     line.ibudgdtkey='';
            //     line.budgetline='';
            // });         
        // }, 200);
    },
    'expLinesObj.ibudgdtkeyflag' : function(newval) {
        setTimeout(() => {
            if (this.expLinesObj.ibudgdtkeyflag=='YES'){
                this.expLinesObj.ibudghdkey='N/A';
                this.expLinesObj.ibudgdtkey='N/A';
                this.expLinesObj.budgetline='';
            } else {
                this.expLinesObj.ibudghdkey=(this.expLinesObj.ibudghdkey=='N/A') ? '':this.expLinesObj.ibudghdkey;
                this.expLinesObj.ibudgdtkey=(this.expLinesObj.ibudgdtkey=='N/A') ? '':this.expLinesObj.ibudgdtkey;
                this.expLinesObj.budgetline=(this.expLinesObj.ibudgdtkey=='N/A') ? '':this.expLinesObj.budgetline;
            }
            this.$forceUpdate();
        }, 100);
    },   
  },
  created: async function(){
      
    //   this.routeAsal = localStorage.getItem('ExpreimbMenu');
        console.log('this.$route.params',this.$route.params);
      if (this.$route.params.crewkey) {
        this.adminAdv=false;
        const {user} = this.$store.state;
        this.model.crewinfo = user.full_name + ' | ' + user.crewnik.trim();
        this.model.crewkey = user.crewkey;
        this.model.dibayarke = user.full_name.trim();
        this.model.final= 0;
        const dim = this.dimension.find(d => d.RelatedObj=='department');
        if (dim) {
            this.model[`${dim.value}`] = user.departkd;
            this.model[`${dim.value}Txt`] = user.departemen;
            this.model[`${dim.value}Info`] = user.departkd + ' | ' + user.departemen;
        }

      }
      if (this.$route.params.expenKey)  {
          toastr.info('Loading EXPENSE REIMBURS Detail, please wait')
          try {
            const [a,b,c,data] = await Promise.all([expense.payablegroup(),expense.currency(),expense.pasalpph(),expense.detail(this.$route.params)]) ;
            this.postGroups = a;
            this.currency = b;
            this.lookupPPH = c;

            // const data = await expense.detail(this.$route.params);  
            const row = data[0][0];            

            if ((this.model.send2wf==1) && (user.use_wfservice==1)) {
                this.saveEnabled=false;
            }
            if ((row.posting==1) || (row.nomorbank)) this.saveEnabled= false;
            
            row.tglRequ = row.tglRequ ? moment(row.tglRequ).format('YYYY-MM-DD') : '';
            row.tglBayar = row.tglBayar ? moment(row.tglBayar).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.tanggalBerubah();
            this.expLines.items = data[1];
            this.expLines.total=this.expLines.items.length;
            this.calcDtlExp();
            this.updateDimHdr = !this.updateDimHdr;
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
         this.model.tglRequ = moment().format('YYYY-MM-DD');
         this.tahun=this.model.tglRequ.substring(0,4);
            const [a,b,c, e] = await Promise.all([expense.payablegroup(),expense.currency(),expense.pasalpph(), expense.getcoa({ tahun: this.tahun})]) ;
            this.postGroups = a;
            this.currency = b;
            this.lookupPPH = c;
            this.coa = e;
      }

    this.$watch('expLinesObj.pasalpph', function(newval) {
        if (this.watching_pasalpph==true) {
            const item = this.lookupPPH.find(p => p.value==newval);
            if (item) {
                console.log('watching_pasalpph: ', item.pph);
                this.expLinesObj.pph=item.pph;
                setTimeout(() => {
                    this.calcTaxes();
                }, 100);
            }
        }
    });            
    // this.watching_pasalpph=true;
    this.$watch('expLinesObj.kodeacc', function(newval) {
      setTimeout(() => {
          if ((this.expLinesObj.kodeacc === newval) && (newval)) {
        //   if (newval) {
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
                // console.log(' coa diketik : ', _selected);
                this.expLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.expLinesObj.kodeacc = _selected.kodeacc;
                this.expLinesObj.namaacc = _selected.namaacc;
                this.$forceUpdate();  
                this.dimension.forEach((dim) => {
                    if (_selected[dim.value]) {
                        this.expLinesObj[dim.value] = _selected[dim.value];
                        this.expLinesObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                        // this.expLinesObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                        this.expLinesObj[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
                    }
                });      
            } else {
                this.expLinesObj.kodeacc='';
                this.expLinesObj.namaacc = '';
            }
          }
      }, 500);
    });            

  },
  methods: {
    onSelectLkuBudget: async function (_selected) {
        try {
            this.model.remark = _selected.uraian;
            this.model.budgetname = _selected.uraian;
            this.model.budgetnumber = _selected.nomorintern;
            // this.model.jccostname = _selected.jccostname;
            this.model.budgetinfo = _selected.nomorintern+' | '+_selected.uraian;
            this.model.nomorproduksi = _selected.noprodintern;
            // this.model.ibudgdtkey = _selected.ibudgdtkey;
            this.model.ibudghdkey = _selected.ibudghdkey;
            this.model.pjxbudgkey = _selected.pjxbudgkey;
            this.model.pjxkey = _selected.pjxhdrkey;
            this.model.DimTableKey = _selected.DimTableKey;
            // this.budgetbalance = _selected.ibbudgetamt -_selected.requestamt;

            this.model.expectreceipt = _selected.requstart ? moment(_selected.requstart).format('YYYY-MM-DD') : '';
            this.dimension.forEach((dim) => {
                if (_selected[dim.value]) {
                    this.model[dim.value] = _selected[dim.value];
                    this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                    this.model[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
                }
                if (dim.RelatedObj=='internalbudget') {
                    this.model[`${dim.value}`] = _selected.nomorintern;
                    this.model[`${dim.value}Txt`] = _selected.uraian + ' # '+ _selected.noprodintern;
                    this.model[`${dim.value}Info`] = _selected.nomorintern + ' | '+ _selected.uraian + ' # '+ _selected.noprodintern;
                }
            });
            this.updateDimHdr=!this.updateDimHdr;

            this.lkuBudgetShow=false;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    },
    onSelectLkuBudgetIntern: async function (ibLineObj) {
        try {
            this.expLinesObj.jccostname = ibLineObj.selected.jccostname;
            this.expLinesObj.budgetline = `${ibLineObj.selected.jccostname} ${ibLineObj.selected.jccostnote}`;
            this.expLinesObj.ibudgdtkey = ibLineObj.selected.ibudgdtkey;
            this.expLinesObj.ibudghdkey = ibLineObj.selected.ibudghdkey;
            this.expLinesObj.ibudgdtkeyflag= 'NO';
            if (!(this.expLinesObj.uraian))  this.expLinesObj.uraian=this.expLinesObj.budgetline;
            this.lkuBudgetInternShow=false;
            this.lkuBudgetInternData=ibLineObj;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    },
    tanggalBerubah: function(){
        const newval=moment(this.model.tglRequ).format('YYYY');
        if ( this.tahun != newval) {
            this.tahun=newval;
            expense.getcoa({ tahun: this.tahun}).then(result => {
                    this.coa = result;
                        if  (this.coa.length==0) {
                            this.getCoa();
                        }                        
                    })
                    .catch(err => {
                        console.log('get COA -> ', err);
                    });
            } else if  (this.coa.length==0) {
                this.getCoa();
            }
    },
    getCoa: function(){
        this.tahun=(this.$store.state.user.tglaktif || '').substring(0,4)                
        expense.getcoa({ tahun: this.tahun}).then(result => {
                this.coa = result;
            })
            .catch(err => {
                console.log('get COA -> ', err);
            });
    },        
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this[this.lkuCashflowCaller].cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this[this.lkuCashflowCaller].kodecash = lkuData.selected.kodecash;
        this[this.lkuCashflowCaller].namacash = lkuData.selected.namacash;
        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
            this.model.kodecash = lkuData.selected.kodecash;
            this.model.namacash = lkuData.selected.namacash;
        }
    },
    onSelectLkuCrew: async function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        if (this.adminAdv) {
            this.model.crewinfo = lkuData.selected.crewname.trim() + ' | ' + lkuData.selected.crewnik.trim();
            this.model.crewkey = lkuData.selected.crewkey;
            this.model.dibayarke = this.model.dibayarke || lkuData.selected.crewname.trim();

            const dim = this.dimension.find(d => d.RelatedObj=='department');
            if (dim) {
                this.model[`${dim.value}`] = this.$store.state.user.departkd;
                this.model[`${dim.value}Txt`] = this.$store.state.user.departemen;
                this.model[`${dim.value}Info`] = this.$store.state.user.departkd + ' | ' + this.$store.state.user.departemen;
            }

        }
        this.lkuCrewShow=false;
    },
    onSelectLkuCoa(_selected) {
        this.expLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.expLinesObj.kodeacc = _selected.kodeacc;
        this.expLinesObj.namaacc = _selected.namaacc;
        this.dimension.forEach((dim) => {
            if (_selected[dim.value]) {
                this.expLinesObj[dim.value] = _selected[dim.value];
                this.expLinesObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                this.expLinesObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                // this.expLinesObj[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
            }
        });        
        this.lkuCoaShow=false;
    },
    async onSelectLkuExpnote(_selected) {
        if (!(this.model.keterangan)) this.model.keterangan= _selected.namadana;
        const listtrx = await expense.detailNote(_selected);
        let seqNo=1;
        let obj;
        listtrx.forEach((b)=>{
            if (b.kasbon !=1 ){
                obj= {
                    uraian: b.uraian,
                    kodeacc: b.kodeacc,
                    namaacc: b.namaacc,
                    glAccount: `${b.kodeacc} | ${b.namaacc}`,
                    nilai: b.nilai,
                    reff: b.reff,
                    seqNo: seqNo++,
                    grossup: b.grossup,
                    kenappn: b.kenappn,
                    ppn: b.ppn,
                    nilaippn: b.nilaippn,
                    dppnlain: b.dppnlain,
                    dpp: b.dpp,
                    kenapph: b.kenapph,
                    nilaipph: b.nilaipph,
                    pph: b.pph,
                    pasalpph: b.pasalpph,
                },
                this.dimension.forEach((dim) => {
                    if (b[dim.value]) {
                        obj[dim.value] = b[dim.value];
                        obj[`${dim.value}Txt`] = b[`${dim.value}Txt`];
                        // obj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
                    }
                });
                this.expLines.items.push(obj);
            }
        });
        this.expLines.total=this.expLines.items.length;
        this.calcDtlExp();
        if (!(this.model.jumlah)) this.model.jumlah= this.model.ttlnetto;
        this.lkuExpnoteShow=false;
    },
    closeExpLines: function(){
        const opened= this.expLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addExpLines : function () {
        this.closeExpLines();
        const obj={_showDetails:true,kodeacc:'', uraian:'',  ppn:this.tarifPPN, dppnlain:100, DimTableKey:''};
        this.watching_pasalpph=false;            
        this.expLines.selected = obj;
        this.expLinesObj.expDtlKey='';
        this.expLinesObj.nilai = 0;
        this.expLinesObj.uraian = '';
        this.expLinesObj.kodeacc = '';
        this.expLinesObj.ppn= this.tarifPPN;
        this.expLinesObj.dppnlain= 100; 
        this.expLinesObj.ibudghdkey='N/A';
        this.expLinesObj.ibudgdtkey='N/A';
        this.expLinesObj.ibudgdtkeyflag='YES';
        this.updateDimHdr2Dtl(this.expLinesObj);
        this.expLines.items.push(obj);
        this.expLines.total=this.expLines.items.length;
        setTimeout(() => {
            const bfore = this.expLines.page;
            const after =Math.ceil((this.expLines.total)/this.expLines.limit);
            if (bfore != after){
                this.expLines.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.expLines.total} items`,'Line/Detail Expenses',10000);
            }

        }, 100);
        this.inputLineBerlanjut=1;
        setTimeout(() => {
            this.watching_pasalpph=true;            
        }, 300);
    },
    editExpLines : function (obj,callback) {
        this.closeExpLines();
        this.expLines.selected = obj;
        this.watching_pasalpph=false;
        this.expLinesObj.nilai = 0;
        this.expLinesObj.uraian = '';
        this.expLinesObj.kodeacc = '';
        this.expLinesObj.ppn= this.tarifPPN;
        this.expLinesObj.dppnlain= 100; 
        this.expLinesObj.ibudghdkey='N/A';
        this.expLinesObj.ibudgdtkey='N/A';
        this.expLinesObj.ibudgdtkeyflag='YES';
        for (var key in obj) {
            this.expLinesObj[key] = obj[key];
        }
        console.log('obj.pph: ', obj.pph);
        this.expLinesObj.pph= obj.pph;
        this.expLinesObj.ibudgdtkeyflag=(this.expLinesObj.ibudgdtkey=='N/A') ? 'YES':'NO';

        this.expLinesObj.dppnlain=this.expLinesObj.dppnlain || 100; 
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.expLinesObj[dim.value] = obj[dim.value];
                this.expLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.expLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        this.inputLineBerlanjut=0;
        setTimeout(() => {
            this.watching_pasalpph=true;            
        }, 300);
        callback();
    },
    calcTaxes : function() {
        this.expLinesObj.dpp = parseFloat(this.expLinesObj.nilai) * parseFloat(this.expLinesObj.dppnlain) / 100;
        // if (this.expLinesObj.kenappn == 1) {
        //     this.expLinesObj.grossup = 0;
        //     this.expLinesObj.ppn = this.expLinesObj.ppn || this.tarifPPN;
        // } else {
        //     this.expLinesObj.dpp = 0;
        //     this.expLinesObj.ppn = 0;
        // }
        // if (this.expLinesObj.grossup == 1)
        //     this.expLinesObj.dpp = this.expLinesObj.dpp * (100 / (100 - this.expLinesObj.pph));

        if (this.expLinesObj.grossup == 1)
            this.expLinesObj.dpp = this.expLinesObj.dpp * (100 / (100 - parseFloat(this.expLinesObj.pph)));

        this.expLinesObj.nilaippn = 0;
        if (this.expLinesObj.kenappn == 1) 
            this.expLinesObj.nilaippn = (parseFloat(this.expLinesObj.ppn)/100) * this.expLinesObj.dpp;
            
        if (this.calcPPh == 1)
            this.expLinesObj.nilaipph = this.expLinesObj.dpp * parseFloat(this.expLinesObj.pph) / 100;
    },

    delExpLines: function (index) {
        if (index > -1) {
            const posisi = (this.expLines.page-1)*this.expLines.limit;
            this.expLines.items.splice(posisi+index, 1);
        }
        this.expLines.total=this.expLines.items.length;
        this.calcDtlExp();
    },
    saveExpLines: async function (callback) {
        if (this.invalidExpLines) {
            const invalidobj = {};
            for (var key in this.$v.expLinesObj) {
            if (this.$v.expLinesObj[key].$anyError) {
                if (this.$v.expLinesObj[key].$anyError == true) invalidobj[key] = this.$v.expLinesObj[key];
            }
            }
            console.log('validation expLinesObj: ', this.expLinesObj);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            let datadim=this.expLinesObj;
            datadim.TableName = 'expenreimburs_detail';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.expLinesObj) {
                        this.expLines.selected[key] = this.expLinesObj[key];
                    }
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.expLines.selected[dim.value] = datadim[dim.value];
                            this.expLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.expLines.selected.pph = this.expLinesObj.pph;
                    this.expLines.total=this.expLines.items.length;
                    this.updateDimDtl2Hdr(datadim);
                    this.calcDtlExp();
                    this.expLines.selected._showDetails=false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut==1) {
                        for (var key in this.expLinesObj) {
                            this.expLinesObj[key] = "";
                        }
                        this.addExpLines();
                        this.$v.expLinesObj.$reset();                        
                    }                    
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE",10000);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    save: async function () {
        this.isLoading=true;            
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            this.isLoading=false;            
            return;
        }
        if (this.invalidModel) {
            const invalidobj = {};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
            }
            }
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);

            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;            
        } else if (Math.abs(this.model.jumlah-parseFloat(this.model.ttlnetto))>0.5) {
            toastr.error('[Total Expenses Reimbursment] not Balance with [Total Detail Expenses]', "ERROR MESSAGE",10000);
            this.isLoading=false;            
        } else {
            try {
                this.model.TableName = 'expense';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    this.model.expenKey = this.model.expenKey || '';
                    this.model.nomor = this.model.nomor || '';
                    this.model.final= 0;
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tglRequ = moment(row.tglRequ).format('YYYY-MM-DD');
                    row.tglBayar = row.tglBayar ? moment(row.tglBayar).format('YYYY-MM-DD') : undefined;
                    
                    let lineno=1;
                    let budgetLineExist=false;
                    let itemValid=false;
                    let newExpLines = this.expLines.items.reduce((newArr, item) => {
                        if ((item.uraian) && (item.nilai)) {
                                if (this.model.ibudghdkey) {
                                    if (item.ibudgdtkey) {
                                        if (item.ibudghdkey=='N/A')
                                            itemValid= true;
                                        else {
                                            if (this.model.ibudghdkey==item.ibudghdkey) {
                                                itemValid= true;
                                                budgetLineExist=true;
                                            } else {
                                                itemValid= false;
                                                throw new Error(`Expenses "${item.uraian}" refer to Budget Line NOT FROM Internal Budget`);
                                            }
                                        }
                                    } else itemValid= false;
                                } else itemValid= true;

                            if (itemValid==true) {
                                item.seqNo=lineno;
                                item.duedate = moment(item.duedate || this.model.tglRequ).format('YYYY-MM-DD')
                                newArr.push(item);
                                lineno += 1;
                            }
                        }
                        return newArr;
                    }, []);

                    if ((this.model.ibudghdkey) && (budgetLineExist==false)) {
                        toastr.error('There are no reference to [Internal Budget Line]', "Error - Line/Detail Expenses",10000);
                        this.isLoading=false;  
                        return;          
                    }
                    row.lines = newExpLines;
                    const hasil= await expense.save(row);
                    toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Expense Reimburs",10000);
                        this.isLoading=false;            

                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.saveEnabled=true;
                        // const jenisAdv = this.model.jenisAdv;
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        // this.model.jenisAdv = jenisAdv;
                        this.expLines.items=[];
                        this.expLines.total=0;
                        this.calcDtlExp();
                        this.$v.model.$reset();                        
                    }
                } else {
                    this.isLoading=false;            
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                }

            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                   
            }

        }
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.expLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcDtlExp: function () {
        let ttlnetto = 0;
        this.expLines.items.forEach( function (item) {
            if ((item.uraian) && (item.nilai)) {
                // ttlnetto += (item.nilai || 0);
                // if (item.grossup==1) {
                //     item.nilaiexp = (item.nilai || 0)+(item.nilaipph || 0)+(item.nilaippn || 0)
                // } else {
                //     item.nilaiexp = (item.nilai || 0)-(item.nilaipph || 0)+(item.nilaippn || 0)
                // }
                
                if (item.grossup==1) {
                    item.nilaiexp = (item.nilai || 0)+(item.nilaippn || 0)
                } else {
                    item.nilaiexp = (item.nilai || 0)-(item.nilaipph || 0)+(item.nilaippn || 0)
                }
                ttlnetto += (item.nilaiexp || 0);
            }
        });
        this.model.ttlnetto = ttlnetto;
    },
    close(){
        if (this.adminAdv==true) {
            router.push({ name: "advance.expreimburs" });
        } else {
            router.push({ name: "advance.myexpreimburs" });
        }
    }
  }
};
</script>
